<template>
<div>
<newDevLog>

</newDevLog>



      <el-table
    :data="tableData"
    stripe
    style="width: 100%;white-space:pre-wrap"
    height="750"
    >
    <el-table-column
      prop="id"
      label="编号"
      width="80">
    </el-table-column>
    <el-table-column
      prop="title"
      label="title"
      width="200">

    </el-table-column>
    <el-table-column
      prop="author"
      label="author"
      width="100">

    </el-table-column>



    <el-table-column  
      label="content"
      >

      <template slot-scope="scope">
        <div v-html="scope.row.content"  style="white-space: pre-wrap;"></div>
        
      </template>
   
    </el-table-column>
    <el-table-column
   
      prop="create_time"
      label="time"  width="200" >
    </el-table-column>



    <el-table-column
      fixed="right"
      label="操作"
      width="100">
      <template slot-scope="scope">
        <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
        
      </template>
    </el-table-column>


  </el-table>



  
    </div>
  </template>
  
  <script>

import newDevLog from './newDevLog.vue'; 


export default {
  components: {
    newDevLog
},

methods: {
      handleClick(row) {
        //var  id  =  row.id
        //console.log("id====  "+ id);
        //var rq = "/da/del_dev_log"+`?id=${id}`

        this.$http.get("/v1/del_dev_log/"+ row.id).then( (response)=>  {
          location.reload();
//console.log(id);
  })


       
      }
    },


    data() {
      return {
        tableData: []
      }
    },
created:function(){
  //注意回调函数的作用域!!!
  this.$http.get("/v1/all_dev_log").then( (response)=>  {
this.tableData = response.data
    console.log(response.data)
  })
},

mounted:function(){
 // console.log("bubbles 挂载完毕")
 console.log("/v1/all_dev_log==>   完毕")
}

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  